/**
 * The brain, over whatever page asked for it.
 *
 * The leads list is the reason it exists, and for the same reason the scanner's
 * report dialog exists: the filters, the sort and the page number all live in
 * component state, so navigating away to a company page throws the week's call
 * list on the floor. A lead with no register code has no company page to go to
 * at all, which is the harder half of the problem - the brain is domain-keyed
 * precisely so those leads are reachable.
 *
 * Same component the register detail page stacks, so there is no second
 * implementation of the card to keep in step.
 */
import { Brain } from "lucide-react";
import { Modal } from "../../../ui";
import type { T } from "../../site-scanner/types";
import { BrainCard } from "./BrainCard";

export function BrainDialog({
  domain,
  canManage,
  me,
  onClose,
  t,
}: {
  domain: string;
  canManage: boolean;
  /** Passed straight through to the card, so a run can say whose it is. */
  me: string;
  onClose: () => void;
  t: T;
}) {
  return (
    // Wider than the CRM's 520px default, and through `width` rather than
    // `max-width`, which `.crm-modal` would ignore. The findings carry full URLs
    // as evidence and they are unreadable in a narrow column.
    <Modal
      title={
        <span className="flex items-center gap-2">
          <Brain className="size-4 text-primary" />
          {domain}
        </span>
      }
      label={t("brain.title")}
      onClose={onClose}
      className="w-[min(920px,100%)]"
    >
      <div className="pt-4">
        <BrainCard domain={domain} canManage={canManage} me={me} t={t} />
      </div>
    </Modal>
  );
}
